export default __webpack_public_path__ + "static/media/tray.c70e5efd.svg";